const mutations = {
  setParams(state, params) {
    state.params = params;
  },
  setParamsMultilingue(state, params) {
    state.paramsMultilingue = params
  },
  setLangues(state, langues) {
    state.langues = langues;
  },
  setCurrentLang(state, langue) {
    state.currentLang = langue
  },
  setTraductions(state, traductions) {
    state.traductions = traductions;
  },
  setConstantes(state, value) {
    state.constantes = value;
  },
  setDonationInfo(state, donation) {
    state.donationInfo = { ...donation };
  },
  setPersonalInfo(state, personalInfo) {
    state.personalInfo = { ...personalInfo }
  },
  setJeVeuxFaireUneDedicace(state, dedicace) {
    state.jeVeuxFaireUneDedicace = dedicace;
  },
  setDedicaceInfo(state, dedicaceInfo) {
    state.dedicaceInfo = { ...dedicaceInfo };
  },
  setContactInfo(state, contactInfo) {
    state.contactInfo = { ...contactInfo }
  },
  setCampaign(state, campaign) {
    state.params.campaign = campaign;
  },
  setCampaignSlug(state, slug) {
    state.campaignSlug = slug;
  },
  setCurrentURL(state, url) {
    state.url = url;
  },
  setInfosPaysafe(state, infosPaysafe) {
    state.infosPaysafe = infosPaysafe
  }
};

export default mutations;